import { render } from "./PayoutRecord.vue?vue&type=template&id=2bfc6f46&scoped=true"
import script from "./PayoutRecord.vue?vue&type=script&lang=js"
export * from "./PayoutRecord.vue?vue&type=script&lang=js"

import "./PayoutRecord.vue?vue&type=style&index=0&id=2bfc6f46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfc6f46"]])

export default __exports__